<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 1.tabbar-container-start -->
    <tabbar :goodsNumber="goodsNumber" :tabbarIndex="1"></tabbar>
    <!-- 1.tabbar-container-end -->

    <!-- 2.main-container-start -->
    <div class="main">
      <div class="df-maina-ddtit"><span>订单支付</span></div>
      <div class="goBack">
        <el-button
          size="small"
          style="width:90px;margin-top:50px;background:#9cbbd8;color:#fff;"
          @click="goBack"
        >
          返 回
        </el-button>
      </div>
      <div class="bottom flexStyle4" style="width:1200px;margin:0 auto;">
        <div class="name">订单批次: {{ batchName || "暂无批次" }}</div>
        <div class="mny">付款金额:{{ to_f(res) }}元</div>
        <div class="mny">账户余额:{{ to_f(balance) }}元</div>
        <div class="tips oneLine">注：{{ tipsMsg }}</div>
      </div>
      <div class="bottom flexStyle4">
        <div class="payMode flexStyle1">
          <div class="left">支付方式:</div>
          <el-select v-model="payType" name="" id="">
            <el-option
              :value="item.id"
              v-for="(item) of payTypeList"
              :label="item.text"
              :key="item.id"
              >{{ item.text }}</el-option
            >
          </el-select>
        </div>
        <div class="total">
          <span
            >付款金额：<span>{{ to_f(res) }}元</span></span
          >
          <el-button
            :loading="loadingSubmit"
            size="small"
            style="width:120px;background:#9cbbd8;color:#fff;"
            @click="payBefore"
          >
            {{ loadingSubmit ? "支付处理中" : "确认支付" }}
          </el-button>
        </div>
      </div>
    </div>
    <!-- 2.main-container-end -->

    <!-- 100.footer-container-start -->
    <c-footer></c-footer>
    <!-- 100.footer-container-end -->

    <!-- 微信支付二维码 -->
    <div class="wechat flexStyle1" v-if="wechatshow">
      <div class="main">
        <div class="tips" v-if="paySuccessShow">
          成功支付金额 <span>{{ res }}</span> 元
          <span @click="submitPay" class="hands c-animation2">确认</span>
        </div>
        <div class="text">微信收款码</div>
        <div @click="closeWechatpay" class="close hands c-animation3">关闭</div>
      </div>
    </div>
    <div id="wechatcode" class="wechatcode"></div>
    <!-- 微信支付二维码 -->

    <!-- 支付宝支付 -->
    <div class="wechat flexStyle1" v-if="alipayshow">
      <div class="main main2">
        <div class="text" v-if="!paySuccessShow">支付宝付款中...</div>
        <div class="tips tips2" v-else>
          成功支付金额 <span>{{ res }}</span> 元
          <span @click="submitPay" class="hands c-animation2">确认</span>
        </div>
        <div @click="closeWechatpay" class="close hands c-animation3">关闭</div>
      </div>
    </div>
    <!-- 支付宝支付 -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
import {
  payStatusRequest,
  submitPayRequest,
  shoppingCarNumber,
  getUserBaseInfoRequest,
  payRequest,
  clearCartRequest,
  getBatchInfoRequest,
} from "../../public/js/service";
import QRCode from "qrcodejs2";

export default {
  data() {
    // 1.data
    return {
      res: 0, // 1.1.付款金额
      batchName: "", // 1.2.批次name
      goodsNumber: 0, // 1.3.购物车商品数量
      payType: "0", // 1.4.支付方式(0余额 1支付宝 2微信)
      balance: 0,
      loadingSubmit: false,
      paymentMethodId: 1, // 1.5.支付方式id(1:支付宝;2:微信)，通过payType获取
      payAmount: "", // 1.6.充值金额，应该用不上
      returnUrl: "", // 1.7.支付成功跳转地址
      ip: "", // 1.8.请求ip
      bathId: "", // 1.9.代发结算批次id,余额支付时必传。
      wechatshow: false,
      alipayshow: false,
      payNum: "", // 1.10.支付单据号，用于查询当前支付状态
      payStatusTimer: null, // 1.11.轮训支付订单状态timer
      paySuccessShow: false,
      payTypeList: [{ id: "0", text: "余额" }],
      tipsMsg: "余额不足时，请先充值。",
      subTimer: null,
    };
  },

  components: {
    // 2.components
    tabbar, // 2.1.tabbar
    cFooter: footer, // 2.2.footer
  },

  methods: {
    // 3.methods
    goBack() {
      // 3.1.返回
      this.$router.go(-1);
    },

    getGoodsNumber() {
      // 3.2.获取购物车信息
      shoppingCarNumber().then((res) => {
        if (res) {
          this.goodsNumber = res.data;
        }
      });
    },

    payBefore() {
      // 3.3.支付之前
      let _this = this;
      this.$msgbox({
        title: "提示",
        message: "是否确认支付?",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback(res) {
          if (res == "confirm") {
            _this.loadingSubmit = true;
            if (_this.payType == 0) {
              _this.balancepay();
              _this.subTimer = setInterval(() => {
                _this.pay2Stauts();
              }, 3000);
            } else {
              _this.wechatdnaliPay();
            }
          }
        },
      });
    },

    balancepay() {
      // 3.4.余额支付
      let data = {
        ids: this.ids,
        payType: this.payType,
      };
      payRequest(data).then((res) => {
        if (res) {
          if (res.data.code == 500) {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
            clearInterval(this.subTimer);
            this.loadingSubmit = false;
          } else {
            // this.$message({
            //   type: "success",
            //   message: "支付成功",
            // });
            // this.clearShoppingCar();
            // this.getUserInfo();
            // setTimeout(() => {
            //   this.$router.push("/orderCenter?buttonIndex=2");
            // }, 600);
          }
        }
      });
    },

    clearShoppingCar() {
      // 3.5.支付成功后清空购物车
      clearCartRequest({ isCheck: 0 });
    },

    getUserInfo() {
      // 3.6.获取用户信息
      getUserBaseInfoRequest().then((res) => {
        if (res) {
          this.userInfo = res.data;
          localStorage.userInfo = JSON.stringify(res.data);
        }
      });
    },

    wechatdnaliPay() {
      // 3.7.微信支付宝支付方式请求
      this.openLoading();
      let data = {
        paymentMethodId: this.payType,
        payAmount: this.res,
        returnUrl: this.returnUrl,
        ip: this.ip,
        bathId: this.bathId,
      };

      submitPayRequest(data).then((res) => {
        this.closeLoading();
        if (res) {
          if (this.payType == 1) {
            this.alipay(res);
          } else if (this.payType == 2) {
            this.wechatpay(res);
          }
        }
      });
    },

    alipay(res) {
      // 3.8.支付宝支付
      this.payNum = res.data.payNum;
      this.alipayshow = true;
      this.watchPayStatus();

      let divForm = document.getElementsByTagName("divform");

      if (divForm.length) {
        document.body.removeChild(divForm[0]);
      }

      const div = document.createElement("divform");
      div.innerHTML = res.data.payCode;
      document.body.appendChild(div);
      document.forms[0].setAttribute("target", "_blank");
      document.forms[0].submit();
    },

    wechatpay(res) {
      // 3.9.微信支付
      this.payNum = res.data.payNum;
      this.watchPayStatus();

      new QRCode("wechatcode", {
        width: 200,
        height: 200,
        text: res.data.payCode,
        colorDark: "#000",
        colorLight: "#fff",
      });

      this.wechatshow = true;
    },

    closeWechatpay() {
      // 3.10.关闭支付
      clearInterval(this.payStatusTimer);
      this.$router.go(0);
    },

    submitPay() {
      // 3.11.确认支付完成
      clearInterval(this.payStatusTimer);
      this.$router.push("/orderCenter?buttonIndex=2");
    },

    watchPayStatus() {
      // 3.12.根据支付单据编号查询单据状态
      this.payStatusTimer = setInterval(() => {
        this.payStauts();
      }, 3000);
    },

    payStauts() {
      // 3.13.状态查询
      let data = {
        payNum: this.payNum,
      };

      payStatusRequest(data).then((res) => {
        if (res) {
          if (res.data.status == 0) {
            // 3.13.1.支付状态为成功
            clearInterval(this.payStatusTimer);
            this.paySuccessShow = true;
          }
        }
      });
    },
    pay2Stauts() {
      // 3.13.状态查询
      getBatchInfoRequest(this.bathId).then((res) => {
        if (res) {
          if (res.data.status == 0) {
            // 3.13.1.支付状态为成功
            clearInterval(this.subTimer);
            //this.loadingSubmit = false;
            this.$message({
              type: "success",
              message: "支付成功",
            });
            this.clearShoppingCar();
            this.getUserInfo();

            setTimeout(() => {
              this.$router.push("/orderCenter?buttonIndex=2");
            }, 600);
          }
        }
      });
    },
    openLoading() {
      // 3.14.打开加载遮罩层
      this.loadingInstance = this.$loading.service({
        fullscreen: true,
        lock: true,
      });
    },

    closeLoading() {
      // 3.15.关闭遮罩层
      this.loadingInstance.close();
    },
  },

  mounted() {
    let payAry = [];
    payAry.push({ id: "0", text: "余额" });

    // 4.mounted
    if (this.$route.query.obj2) {
      this.obj2 = JSON.parse(decodeURIComponent(this.$route.query.obj2));
      //this.obj3 = JSON.parse(decodeURIComponent(this.$route.query.obj3));
      this.res = this.obj2.res;
      this.batchName = this.obj2.batchName;
      this.ids = [this.obj2.batchId];
      this.bathId = this.obj2.batchId;

      if (localStorage.token) {
        this.token = localStorage.token;
        this.getGoodsNumber();
      }
      if (localStorage.baseInfo) {
        let obj = JSON.parse(localStorage.baseInfo);
        if (obj.web_pay_type) {
          let pAry = obj.web_pay_type;
          let isOpenPay = pAry.length;
          for (let p = 0; p < isOpenPay; p++) {
            payAry.push({
              id: pAry[p].paymentMethodId + "",
              text: pAry[p].paymentMethodName,
            });
          }
          if (isOpenPay <= 0) {
            this.tipsMsg = "余额不足时，请先充值。";
          } else {
            this.tipsMsg = "余额不足时，请先充值。";
          }
        }
      }
      this.payTypeList = payAry;
      this.payType = "0";
    }

    this.timer = setInterval(() => {
      if (localStorage.userInfo) {
        clearInterval(this.timer);
        this.userInfo = JSON.parse(localStorage.userInfo);
        this.balance = this.userInfo.balance;
      }
    }, 20);

    this.returnUrl =
      window.location.protocol +
      "//" +
      window.location.hostname +
      "/#/financeCenter?buttonsIndex=4";
    this.ip = localStorage.getItem("Ip");
  },

  destroyed() {
    clearInterval(this.payStatusTimer);
    clearInterval(this.subTimer);
  },
};
</script>

<style scoped lang="scss">
@import "./pay.scss";
</style>
